// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"d976338c","769":"69003562"}[chunkId] + ".chunk.js";
};